import type { ReactNode } from 'react';

/**
 * The console's page header, same markup and classes as the web app's
 * (style guide 2.9b): the one `h1` (focus target after a navigation), an
 * optional description and one action slot on the right.
 */
export function PageHeader({ title, description, actions }: { readonly title: ReactNode; readonly description?: ReactNode; readonly actions?: ReactNode }) {
  return (
    <div className="ui-page-head">
      <header className="ui-page-header">
        <div className="ui-page-header__main">
          <div className="ui-page-header__titlerow">
            <h1 tabIndex={-1}>{title}</h1>
          </div>
          {description ? <p className="ui-page-header__description">{description}</p> : null}
        </div>
        {actions ? <div className="ui-page-header__actions">{actions}</div> : null}
      </header>
    </div>
  );
}
